import {
  bowserWindowsOsName,
  BrowserList,
  LastSupportChromeMajorVersionWindows78,
  OperationSystem,
  SupportEmojiDisplayBrowserList,
  SupportEmojiDisplayMobilePlatform,
} from 'common-constants/bowser'
import { parseBrowserVersion } from 'functions/resolveIosVersion'

/**
 * @param osName
 * @param osVersion
 * @param browserName
 * тут есть проблема почему то firefox отдает версию 10.16 когда на самом деле уже 11.1 для macOS
 */
export const isSupportNativeEmojiDisplay = (
  osName: OperationSystem,
  osVersion: string,
  browserName: BrowserList,
  browserVersion: string
) => {
  /**
   * Для window там NT 10.0
   */
  const _osVersion =
    osName === bowserWindowsOsName && osVersion.includes('NT')
      ? osVersion.split(' ')[1]
      : osVersion

  const [majorVersion, minorVersion] = _osVersion.split('.')

  const numberMajorVersion = Number(majorVersion)
  const numberMinorVersion = Number(minorVersion)

  if (SupportEmojiDisplayMobilePlatform.includes(osName)) {
    return true
  }

  /**
   * MacOS поддерживает с 10.8 emoji
   */
  if (osName === OperationSystem.MacOs) {
    return (
      numberMajorVersion > 10 ||
      (numberMajorVersion > 9 && numberMinorVersion > 8)
    )
  }

  if (osName === bowserWindowsOsName && Number(majorVersion) > 9) {
    /**
     * Проблема в том что chrome на любой версии windows всегда возвращает
     * NT 10.0.
     * Поэтому берем последнюю поддерживаю версию на WIN 7-8
     * и сравнением с тем что есть.
     */
    if (browserName === BrowserList.Chrome) {
      const [major] = parseBrowserVersion(browserVersion)

      return major > LastSupportChromeMajorVersionWindows78
    }

    return SupportEmojiDisplayBrowserList.includes(browserName)
  }

  return osName === OperationSystem.Linux
}
